const userGlobalConfig = {
  TOKEN: "woof admin token",
};

export default userGlobalConfig;